import Avatar from "../../common/Avatar";
import { useDispatch } from "react-redux";
import { openModal } from "../../../features/globalModalSlice";
import { users } from "../../../fake-db/users";
import { useParams } from "react-router-dom";

const UserInfo = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const user = users.filter((item) => {
    return `${item.id}` === (id || "1");
  });

  return (
    <button
      onClick={() => dispatch(openModal("right"))}
      className="flex items-center gap-2 text-slate-600 text-base font-medium text-left"
    >
      <Avatar
        isSmall={false}
        data={user[0]}
        activeStatus={user[0]?.isActive && true}
      />
      <div className="">
        <h5 className="text-slate-500 font-medium text-[15px]">
          {user[0].name}
        </h5>
        <p className="text-slate-400 text-[12px] -mt-[5px] sm:hidden md:block">
          {user[0].profession}
        </p>
      </div>
    </button>
  );
};

export default UserInfo;
